module.exports = __webpack_public_path__ + "static/img/icon_02.c59bb989.png";